import React from "react";

export function PreviewTable({ dataSource, columns }) {
    if (dataSource && columns) {
        return (
            <>
                <table className="preview-table" border="1" style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <thead>
                        <tr>
                            {columns?.map((col) => (
                                <th key={col.key} style={{ textAlign: col.align }}>
                                    {col.title}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {dataSource?.map((row, index) => (
                            <tr key={index}>
                                {columns.map((col) => (
                                    <td key={col.key} style={{ textAlign: col.align }}>
                                        {col.render ? col.render(row[col.dataIndex], row, index) : row[col.dataIndex]}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </>
        );
    } else {
        return null;
    }
}